export function splitContactName(name = '') {
    const clean = String(name).trim().replace(/\s+/g, ' ');
    const ambiguous = /@|\b(llc|inc|corp|corporation|company|ltd|llp|services|transportation|group)\b/i.test(clean)
        || clean.split(' ').length > 3;
    if (ambiguous) return { firstName: '', lastName: '', review: true };
    const space = clean.indexOf(' ');
    return { firstName: space < 0 ? clean : clean.slice(0, space), lastName: space < 0 ? '' : clean.slice(space + 1), review: false };
}
export function contactDisplayName(firstName = '', lastName = '') {
    return [firstName.trim(), lastName.trim()].filter(Boolean).join(' ');
}
